<template>
  <section class="about-gift-card">
    <div class="about-gift-card__content">
      <h3 class="about-gift-card__title">
        <span>キモチが伝わる</span><span>ギフトカード</span>
      </h3>
      <div class="about-gift-card__original mt-48">
        <h4 class="about-gift-card__sub-title">オリジナルギフトカード</h4>
        <p class="about-gift-card__caption mt-16 mb-32">
          お子様の写真やウェディングフォト、<br />
          <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
          クリエイターの方はご自身のイラストなど<br class="less-than-pc-br" />お好きな画像を設定して、<br />
          世界に一つのギフトカードを作成いただけます。
        </p>
        <div class="about-gift-card__original--gift-card-images">
          <div>
            <ImgLazy
              :image-url="GiftCard1Image"
              alt-text="内祝いとして赤ちゃんの写真を添えたギフトカード"
              aspect-ratio="462 / 823"
              class="about-gift-card__original--gift-card-images-item"
            />
          </div>
          <div>
            <ImgLazy
              :image-url="GiftCard2Image"
              alt-text="結婚式参列のお礼としてウェディングフォトを添えたギフトカード"
              aspect-ratio="462 / 823"
              class="about-gift-card__original--gift-card-images-item"
            />
          </div>
          <div>
            <ImgLazy
              :image-url="GiftCard3Image"
              alt-text="インフルエンサーがファンに贈る謝礼としてイラストを添えたギフトカード"
              aspect-ratio="462 / 823"
              class="about-gift-card__original--gift-card-images-item"
            />
          </div>
        </div>
        <div class="about-gift-card__original--note mt-32">
          <p class="about-gift-card__original--note-text">
            ※ご自身で画像をご用意いただく場合は、gifteeの定める条件を満たしている必要がございます。条件の詳細はお申し込み画面内にてご案内しておりますが、事前に以下の内容はご理解いただいた上、お申し込みを進めていただけますと幸いです。
          </p>
          <p class="about-gift-card__original--note-text">
            【具体的なNG例】著作権で保護されているキャラクターのデザインを使用すること/既存の作品を利用して、二次的に創作した作品を使用すること/第三者が撮影した写真等を、本人の許諾なく使用すること/人物が特定できる写真で、相手の許可なく撮影した写真を使用すること/本サービスでの利用を許諾していない人物の写真を使用すること
          </p>
        </div>
      </div>
      <div class="about-gift-card__card-design mt-48">
        <h4 class="about-gift-card__sub-title">豊富なカードデザインもご用意</h4>
        <p class="about-gift-card__caption mt-16 mb-32">
          オリジナル画像だけでなく、季節やシーンに合う、<br />
          <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
          300種類以上のデザインからも<br class="less-than-pc-br" />ギフトカードを作成いただけます。
        </p>
        <div class="about-gift-card__card-design--images">
          <ImgLazy
            :image-url="CardDesign1Image"
            alt-text="ありがとう カードデザイン"
            aspect-ratio="1 / 1"
            class="about-gift-card__card-design--images-item"
          />
          <ImgLazy
            :image-url="CardDesign2Image"
            alt-text="おめでとう カードデザイン"
            aspect-ratio="1 / 1"
            class="about-gift-card__card-design--images-item"
          />
          <ImgLazy
            :image-url="CardDesign3Image"
            alt-text="内祝い カードデザイン"
            aspect-ratio="1 / 1"
            class="about-gift-card__card-design--images-item"
          />
          <ImgLazy
            :image-url="CardDesign4Image"
            alt-text="ありがとう カードデザイン"
            aspect-ratio="1 / 1"
            class="about-gift-card__card-design--images-item about-gift-card__card-design--images-hidden-item"
          />
          <ImgLazy
            :image-url="CardDesign5Image"
            alt-text="お世話になりました カードデザイン"
            aspect-ratio="1 / 1"
            class="about-gift-card__card-design--images-item about-gift-card__card-design--images-hidden-item"
          />
          <ImgLazy
            :image-url="CardDesign6Image"
            alt-text="ほんの気持ちです カードデザイン"
            aspect-ratio="1 / 1"
            class="about-gift-card__card-design--images-item about-gift-card__card-design--images-hidden-item"
          />
          <ImgLazy
            :image-url="CardDesign7Image"
            alt-text="ハロウィン カードデザイン"
            aspect-ratio="1 / 1"
            class="about-gift-card__card-design--images-item"
          />
          <ImgLazy
            :image-url="CardDesign8Image"
            alt-text="クリスマス カードデザイン"
            aspect-ratio="1 / 1"
            class="about-gift-card__card-design--images-item"
          />
          <ImgLazy
            :image-url="CardDesign9Image"
            alt-text="謹賀新年 カードデザイン"
            aspect-ratio="1 / 1"
            class="about-gift-card__card-design--images-item"
          />
          <ImgLazy
            :image-url="CardDesign10Image"
            alt-text="バレンタイン カードデザイン"
            aspect-ratio="1 / 1"
            class="about-gift-card__card-design--images-item about-gift-card__card-design--images-hidden-item"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import ImgLazy from '../../../atoms/images/ImgLazy.vue'
import GiftCard1Image from '../../../../../../images/bulk_personal_orders/about/gift_cards/gift_card1.png'
import GiftCard2Image from '../../../../../../images/bulk_personal_orders/about/gift_cards/gift_card2.png'
import GiftCard3Image from '../../../../../../images/bulk_personal_orders/about/gift_cards/gift_card3.png'
import CardDesign1Image from '../../../../../../images/bulk_personal_orders/about/card_designs/card_design1.png'
import CardDesign2Image from '../../../../../../images/bulk_personal_orders/about/card_designs/card_design2.gif'
import CardDesign3Image from '../../../../../../images/bulk_personal_orders/about/card_designs/card_design3.png'
import CardDesign4Image from '../../../../../../images/bulk_personal_orders/about/card_designs/card_design4.gif'
import CardDesign5Image from '../../../../../../images/bulk_personal_orders/about/card_designs/card_design5.png'
import CardDesign6Image from '../../../../../../images/bulk_personal_orders/about/card_designs/card_design6.png'
import CardDesign7Image from '../../../../../../images/bulk_personal_orders/about/card_designs/card_design7.png'
import CardDesign8Image from '../../../../../../images/bulk_personal_orders/about/card_designs/card_design8.png'
import CardDesign9Image from '../../../../../../images/bulk_personal_orders/about/card_designs/card_design9.gif'
import CardDesign10Image from '../../../../../../images/bulk_personal_orders/about/card_designs/card_design10.png'
</script>

<style lang="scss" scoped>
.about-gift-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: $gray-3;

  &__content {
    width: 100%;
    max-width: 1440px;
    padding: 96px 72px;
    box-sizing: border-box;

    @media all and (max-width: ($pc-width - 1)) {
      padding: 64px 56px;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      padding: 64px 24px;
    }
  }

  &__title {
    color: $primary;
    font-weight: bold;
    font-size: 4.4rem;
    line-height: 1.6;

    @media all and (max-width: ($pc-width - 1)) {
      font-size: 2.8rem;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      & > span {
        display: block;
      }
    }
  }

  &__sub-title {
    color: $black;
    font-weight: bold;
    font-size: 2.5rem;
    line-height: 1.6;

    @media all and (max-width: ($pc-width - 1)) {
      font-size: 1.8rem;
    }
  }

  &__caption {
    color: $black;
    font-size: 2rem;
    line-height: 1.6;

    @media all and (max-width: ($pc-width - 1)) {
      font-size: 1.4rem;
    }
  }

  &__original {
    &--gift-card-images {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 24px;

      &-item {
        max-width: 230px;
        width: 100%;
        object-fit: contain;

        @media all and (max-width: ($pc-width - 1)) {
          max-width: none;
        }
      }
    }

    &--note {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      text-align: left;

      &-text {
        color: $gray-1;
        font-size: 1.2rem;
        line-height: 1.25;
        // ギフトカード画像の横幅に合わせる
        max-width: calc((230px * 3) + (24px * 2));

        @media all and (max-width: ($pc-width - 1)) {
          max-width: none;
        }
      }
    }
  }

  &__card-design {
    &--images {
      display: grid;
      justify-content: center;
      grid-template-columns: repeat(5, 160px);
      gap: 20px;

      @media all and (max-width: ($pc-width - 1)) {
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;
      }

      @media all and (max-width: ($base-contents-width - 1)) {
        grid-template-columns: repeat(2, 1fr);
      }

      &-item {
        width: 100%;
        object-fit: contain;
      }

      &-hidden-item {
        @media all and (max-width: ($pc-width - 1)) {
          display: none;
        }
      }
    }
  }
}

// PCサイズ未満のときの改行
.less-than-pc-br {
  display: none;
  @media all and (max-width: ($pc-width - 1)) {
    display: block;
  }
}
</style>
